<template>
  <div class="dialog-qrcode-batch-download">
    <el-dialog title="批量下载二维码链接" :visible="visible" @close="onDialogClose">
      <el-form
        label-position="top"
        ref="batchDownloadForm"
        style="width: 50%; margin: 0 auto;"
        :rules="batchDownloadRules"
        :model="batchDownloadForm">

        <el-form-item label="二维码类型" prop="userid">
          <el-select
            style="width: 100%;"
            v-model="batchDownloadForm.qrcodeType"
            placeholder="请选择下载的二维码类型">
            <el-option
              label="单货道购买二维码"
              value="b">
            </el-option>
            <el-option
              label="单货道游戏二维码"
              value="g">
            </el-option>
            <el-option
              label="单货道购买 + 游戏二维码"
              value="bg">
            </el-option>
            <el-option
              label="购物车仅购买二维码"
              value="cb">
            </el-option>
            <el-option
              label="购物车购买+游戏二维码"
              value="cbg">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onBatchDownloadSubmit">确定</el-button>
          <el-button @click="onBatchDownloadCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogQrcodeBatchDownload',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    downloadingDevs: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      batchDownloadForm: {
        qrcodeType: 'b'
      },
      batchDownloadRules: {
        qrcodeType: [
          { required: true, message: '请选择下载的二维码类型', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    onDialogClose () {
      this.$emit('update:visible', false)
    },

    downloadFile (filename, content) {
      // 创建隐藏的可下载链接
      let eleLink = document.createElement('a')
      eleLink.download = filename
      eleLink.style.display = 'none'

      // 字符内容转变成blob地址
      const blob = new Blob([content])
      eleLink.href = URL.createObjectURL(blob)
      // 触发点击
      document.body.appendChild(eleLink)
      eleLink.click()
      // 然后移除
      document.body.removeChild(eleLink)
    },

    downloadSingleChannelQrcode () {
      const result = []
      const typeEnum = {
        'b': '购买',
        'g': '游戏',
        'bg': '购买+游戏'
      }

      // Iter all selected devices
      this.downloadingDevs.forEach(dev => {
        // Iter device's all channels
        for (let i = 1; i <= dev.goods_length; i++) {
          const url = `https://pay.ckingdomtechnology.com/loading/${dev.sn}-sgp-${this.batchDownloadForm.qrcodeType}-${i}`
          result.push(url)
        }
      })

      const filename = `${this.downloadingDevs[0].sn}-${this.downloadingDevs[this.downloadingDevs.length - 1].sn}-${typeEnum[this.batchDownloadForm.qrcodeType]}二维码链接.txt`
      this.downloadFile(filename, result.join('\n'))
    },
    downloadMultipleChannelQrcode (mode) {
      const result = []

      this.downloadingDevs.forEach(dev => {
        const url = `https://pay.ckingdomtechnology.com/loading/${dev.sn}-mgp-${mode}`
        result.push(url)
      })

      const filename = `${this.downloadingDevs[0].sn}-${this.downloadingDevs[this.downloadingDevs.length - 1].sn}-购物车二维码链接.txt`
      this.downloadFile(filename, result.join('\n'))
    },

    onBatchDownloadSubmit () {
      if (this.batchDownloadForm.qrcodeType === 'cb') {
        // 购物车仅购买
        this.downloadMultipleChannelQrcode('b')
      } else if (this.batchDownloadForm.qrcodeType === 'cbg') {
        // 购物车购买+游戏
        this.downloadMultipleChannelQrcode('bg')
      } else {
        this.downloadSingleChannelQrcode()
      }
    },
    onBatchDownloadCancel () {
      this.$emit('update:visible', false)
      this.$refs['batchDownloadForm'].resetFields()
    }
  }
}
</script>

<style lang='scss' scoped>
.dialog-qrcode-batch-download {
}
</style>



// WEBPACK FOOTER //
// src/components/factory/DialogBatchDownloadQrcode.vue